// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__eLVjC","icon":"Alert_icon__CHmFV"};